import React, {useEffect, useState} from 'react';
import {getIdentifierFromSubDomain, isKioskStandAloneRoute} from "../functions";
import {setProjectType} from "@arboxappv4/shared/src/redux/projectSlice";
import {projectTypes} from "@arboxappv4/shared/src/helpers/constants";

const useProjectType = (props) => {
    const { dispatch } = props;
    const [type, setType] = useState(null);

    useEffect(() => {
        const isKioskStandAlone = isKioskStandAloneRoute()
        console.log('isKioskStandAlone', isKioskStandAlone)
        if(isKioskStandAlone) {
            setType(projectTypes.kiosk)
        } else {
            getIdentifierFromSubDomain() //this will throw exception if there is no identifier, so we just need to setType after it succeeded
            setType(projectTypes.site)
        }
    }, []);

    useEffect(() => {
        if(dispatch && type !== null) {
            dispatch(setProjectType(type))
        }
    }, [type]);

    return type
};

export default useProjectType;